module.exports = __webpack_public_path__ + "static/img/z-logo.fdf0d06.png";


//////////////////
// WEBPACK FOOTER
// ./static/z-logo.png
// module id = fl4O
// module chunks = 1